import{createContext}from"react";export const KibAccordionNewContext=createContext({updateTriggers:()=>{},scrollTo:!1});